/* Rasa Wedding Store — tabs + inline product drawers.
   Tiles fetch live in-stock products from their collection via the Section Rendering API
   (/collections/<handle>?section_id=rasa-drawer-products), so nothing is hard-coded.
   Shared by the wedding page and the store visit (campaign) page. */
(function () {
  if (window.__rwsInit) return;
  window.__rwsInit = true;
  var cache = {};
  var root = function () { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; };

  function closeDrawer(scope) {
    if (!scope) return;
    var d = scope.querySelector('[data-rws-drawer]');
    if (d) d.hidden = true;
    scope.querySelectorAll('[data-rws-tile][aria-expanded="true"]').forEach(function (t) { t.setAttribute('aria-expanded', 'false'); });
  }

  function load(handle) {
    if (cache[handle]) return Promise.resolve(cache[handle]);
    return fetch(root() + 'collections/' + encodeURIComponent(handle) + '?section_id=rasa-drawer-products&filter.v.availability=1')
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var items = doc.querySelector('.rws-drawer-items');
        cache[handle] = items ? items.innerHTML : '';
        return cache[handle];
      });
  }

  // In a grid (drawer marked data-rws-inrow), move the drawer to sit right after the last tile on the clicked tile's row.
  function placeInRow(scope, tile, drawer) {
    if (!drawer.hasAttribute('data-rws-inrow')) return;
    var top = tile.offsetTop, last = tile;
    scope.querySelectorAll('[data-rws-tile]').forEach(function (t) {
      if (t.parentNode === tile.parentNode && Math.abs(t.offsetTop - top) < 4) last = t;
    });
    if (last.nextSibling !== drawer) last.parentNode.insertBefore(drawer, last.nextSibling);
  }

  function openTile(tile) {
    var scope = tile.closest('[data-rws-scope]');
    if (!scope) return;
    var drawer = scope.querySelector('[data-rws-drawer]');
    var wasOpen = tile.getAttribute('aria-expanded') === 'true';
    closeDrawer(scope);
    if (wasOpen || !drawer) return;
    var handle = tile.getAttribute('data-handle');
    var label = tile.getAttribute('data-label') || '';
    placeInRow(scope, tile, drawer);
    tile.setAttribute('aria-expanded', 'true');
    drawer.hidden = false;
    drawer.querySelector('[data-rws-title]').textContent = label;
    var viewAll = drawer.querySelector('[data-rws-viewall]');
    viewAll.href = root() + 'collections/' + handle;
    var rail = drawer.querySelector('[data-rws-items]');
    rail.innerHTML = '<p class="rws-loading">Loading…</p>';
    rail.scrollLeft = 0;
    load(handle).then(function (html) {
      if (tile.getAttribute('aria-expanded') !== 'true') return;
      rail.innerHTML = html || '<p class="rws-empty">New pieces arriving soon.</p>';
      var all = rail.querySelector('[data-rws-all]');
      if (all) all.textContent = 'View all ' + label + ' ›';
    }).catch(function () {
      rail.innerHTML = '<p class="rws-empty"><a href="' + root() + 'collections/' + handle + '">See ' + label + ' ›</a></p>';
    });
    if (drawer.getBoundingClientRect().bottom > window.innerHeight) {
      drawer.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
  }

  // Add to cart from a drawer card, then let the theme rebuild and open its cart drawer.
  function addToCart(btn) {
    if (btn.disabled) return;
    var label = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding…';
    fetch(root() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(btn.getAttribute('data-variant')), quantity: 1 }] })
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        if (!res.ok) throw res.d;
        var item = res.d && res.d.items ? res.d.items[0] : res.d;
        btn.textContent = 'Added ✓';
        btn.classList.add('is-added');
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: item, addToCartBtn: btn }, bubbles: true }));
        setTimeout(function () { btn.textContent = label; btn.classList.remove('is-added'); btn.disabled = false; }, 2500);
      })
      .catch(function (err) {
        btn.textContent = err && err.description ? 'Sold out' : 'Try again';
        setTimeout(function () { btn.textContent = label; btn.disabled = false; }, 2500);
      });
  }

  var isDragging = false;
  var dragSuppressionTimer = null;

  function updateSliderArrows(wrap) {
    if (!wrap) return;
    var rail = wrap.querySelector('[data-rws-slider], .rws-rail');
    if (!rail) return;
    var prev = wrap.querySelector('[data-rws-nav="prev"]');
    var next = wrap.querySelector('[data-rws-nav="next"]');
    if (!prev || !next) return;

    var maxScroll = rail.scrollWidth - rail.clientWidth;
    if (maxScroll <= 4) {
      prev.disabled = true;
      next.disabled = true;
      prev.setAttribute('aria-disabled', 'true');
      next.setAttribute('aria-disabled', 'true');
      return;
    }

    var sl = rail.scrollLeft;
    var atStart = sl <= 4;
    var atEnd = sl >= maxScroll - 4;

    prev.disabled = atStart;
    prev.setAttribute('aria-disabled', atStart ? 'true' : 'false');
    next.disabled = atEnd;
    next.setAttribute('aria-disabled', atEnd ? 'true' : 'false');
  }

  function setupSlider(wrap) {
    if (wrap.__rwsSliderInit) {
      updateSliderArrows(wrap);
      return;
    }
    wrap.__rwsSliderInit = true;

    var rail = wrap.querySelector('[data-rws-slider], .rws-rail');
    if (!rail) return;
    var prev = wrap.querySelector('[data-rws-nav="prev"]');
    var next = wrap.querySelector('[data-rws-nav="next"]');

    function getStep() {
      return Math.max(200, Math.round(rail.clientWidth * 0.72));
    }

    if (prev) {
      prev.addEventListener('click', function (e) {
        e.preventDefault();
        rail.scrollBy({ left: -getStep(), behavior: 'smooth' });
      });
    }

    if (next) {
      next.addEventListener('click', function (e) {
        e.preventDefault();
        rail.scrollBy({ left: getStep(), behavior: 'smooth' });
      });
    }

    var isTicking = false;
    rail.addEventListener('scroll', function () {
      if (!isTicking) {
        window.requestAnimationFrame(function () {
          updateSliderArrows(wrap);
          isTicking = false;
        });
        isTicking = true;
      }
    }, { passive: true });

    // Desktop Mouse Drag
    var isDown = false;
    var startX = 0;
    var scrollStart = 0;
    var hasMoved = false;

    rail.addEventListener('mousedown', function (e) {
      if (e.button !== 0) return;
      isDown = true;
      hasMoved = false;
      startX = e.pageX;
      scrollStart = rail.scrollLeft;
    });

    window.addEventListener('mousemove', function (e) {
      if (!isDown) return;
      var dx = e.pageX - startX;
      if (!hasMoved && Math.abs(dx) > 6) {
        hasMoved = true;
        isDragging = true;
        rail.classList.add('is-dragging');
      }
      if (hasMoved) {
        e.preventDefault();
        rail.scrollLeft = scrollStart - dx;
      }
    });

    function endDrag() {
      if (!isDown) return;
      isDown = false;
      rail.classList.remove('is-dragging');
      if (hasMoved) {
        clearTimeout(dragSuppressionTimer);
        dragSuppressionTimer = setTimeout(function () {
          isDragging = false;
        }, 100);
      } else {
        isDragging = false;
      }
    }

    window.addEventListener('mouseup', endDrag);

    updateSliderArrows(wrap);
  }

  function initSliders() {
    document.querySelectorAll('[data-rws-slider-wrap]').forEach(setupSlider);
  }

  function initTablistDrag() {
    document.querySelectorAll('.rws-tablist').forEach(function (tl) {
      if (tl.__rwsTabDrag) return;
      tl.__rwsTabDrag = true;
      var isDown = false, startX = 0, scrollStart = 0, hasMoved = false;
      tl.addEventListener('mousedown', function (e) {
        if (e.button !== 0) return;
        isDown = true; hasMoved = false; startX = e.pageX; scrollStart = tl.scrollLeft;
      });
      window.addEventListener('mousemove', function (e) {
        if (!isDown) return;
        var dx = e.pageX - startX;
        if (!hasMoved && Math.abs(dx) > 6) {
          hasMoved = true;
          isDragging = true;
          tl.style.cursor = 'grabbing';
          tl.style.userSelect = 'none';
        }
        if (hasMoved) {
          e.preventDefault();
          tl.scrollLeft = scrollStart - dx;
        }
      });
      window.addEventListener('mouseup', function () {
        if (!isDown) return;
        isDown = false;
        tl.style.cursor = '';
        tl.style.userSelect = '';
        if (hasMoved) {
          clearTimeout(dragSuppressionTimer);
          dragSuppressionTimer = setTimeout(function () { isDragging = false; }, 100);
        } else {
          isDragging = false;
        }
      });
    });
  }

  function selectTab(tab) {
    var sec = tab.closest('[data-rws-tabs]');
    var i = tab.getAttribute('data-rws-tab');
    sec.querySelectorAll('[data-rws-tab]').forEach(function (t) { t.setAttribute('aria-selected', t === tab ? 'true' : 'false'); });
    sec.querySelectorAll('[data-rws-panel]').forEach(function (p) {
      var show = p.getAttribute('data-rws-panel') === i;
      p.hidden = !show;
      if (!show) {
        closeDrawer(p);
      } else {
        var wrap = p.querySelector('[data-rws-slider-wrap]');
        if (wrap) {
          setupSlider(wrap);
          window.requestAnimationFrame(function () { updateSliderArrows(wrap); });
        }
      }
    });
    if (tab && typeof tab.scrollIntoView === 'function') {
      try { tab.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' }); } catch (err) { }
    }
  }

  document.addEventListener('click', function (e) {
    if (isDragging) {
      e.preventDefault();
      e.stopImmediatePropagation();
      return;
    }
    var add = e.target.closest('[data-rws-add]');
    if (add) { e.preventDefault(); addToCart(add); return; }
    var tab = e.target.closest('[data-rws-tab]');
    if (tab) { selectTab(tab); return; }
    var tile = e.target.closest('[data-rws-tile]');
    if (tile) { openTile(tile); return; }
    var close = e.target.closest('[data-rws-close]');
    if (close) { closeDrawer(close.closest('[data-rws-scope]')); }
  }, true);

  // Open the first tile of any section marked data-rws-autoopen, so visitors see the pattern.
  function autoOpen() {
    document.querySelectorAll('[data-rws-autoopen]').forEach(function (sec) {
      var panel = sec.querySelector('[data-rws-panel]:not([hidden])') || sec;
      var first = panel.querySelector('[data-rws-tile]');
      if (first && first.getAttribute('aria-expanded') !== 'true') openTile(first);
    });
  }
  // Reels: play muted only while on screen (saves data on phones); tap a reel to hear it.
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      var v = en.target;
      if (en.isIntersecting) { v.preload = 'auto'; var p = v.play(); if (p && p.catch) p.catch(function () { }); }
      else { v.pause(); }
    });
  }, { threshold: 0.5 }) : null;
  function initReels() {
    document.querySelectorAll('video[data-rws-reel]').forEach(function (v) {
      if (v.__rws) return; v.__rws = true; v.muted = true;
      if (io) io.observe(v);
    });
  }
  document.addEventListener('click', function (e) {
    var media = e.target.closest('.rws-reel__media');
    if (!media || media.closest('a')) return;
    var v = media.querySelector('video'); if (!v) return;
    v.muted = !v.muted; if (v.paused) v.play();
    var s = media.querySelector('.rws-reel__sound'); if (s) s.textContent = v.muted ? '🔇' : '🔊';
  });

  window.addEventListener('resize', function () {
    document.querySelectorAll('[data-rws-slider-wrap]').forEach(updateSliderArrows);
  }, { passive: true });

  function boot() {
    initSliders();
    initTablistDrag();
    autoOpen();
    initReels();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function () {
    initSliders();
    initTablistDrag();
    initReels();
    autoOpen();
  });
})();
